import React, { useCallback } from 'react';

import { DESKTOP_NOTIFICATION_FIELDS } from '../../common/fields';
import { SUBCATEGORIES } from '../../common/categories';

import * as actions from '../../containers/DesktopApplication/desktopApplicationActions';

import ImageUpload from '../Controls/ImageUpload/ImageUpload';
import SelectField from '../Controls/SelectField/SelectField';
import SwitchField from '../Controls/SwitchField/SwitchField';
import TextInput from '../Controls/TextInput/TextInput';
import Button from '../Controls/Button/Button';

const { DESKTOP_NOTIFICATION } = SUBCATEGORIES;

const DesktopNotification = ({ fields, dispatch, defaultData }) => {
    const notificationIcon = fields[DESKTOP_NOTIFICATION_FIELDS.NOTIFICATION_ICON.ID];
    const notificationBackground = fields[DESKTOP_NOTIFICATION_FIELDS.NOTIFICATION_BACKGROUND.ID];
    const displayIconEnabled = fields[DESKTOP_NOTIFICATION_FIELDS.DISPLAY_ICON_ENABLED.ID];
    const notificationHeight = fields[DESKTOP_NOTIFICATION_FIELDS.NOTIFICATION_HEIGHT.ID];
    const notificationWidth = fields[DESKTOP_NOTIFICATION_FIELDS.NOTIFICATION_WIDTH.ID];
    const windowPosition = fields[DESKTOP_NOTIFICATION_FIELDS.WINDOW_POSITION.ID];
    const notificationTitle = fields[DESKTOP_NOTIFICATION_FIELDS.NOTIFICATION_TITLE.ID];
    const mfaNotificationText = fields[DESKTOP_NOTIFICATION_FIELDS.MFA_NOTIFICATION_TEXT.ID];
    const timeoutNotificationText = fields[DESKTOP_NOTIFICATION_FIELDS.TIMEOUT_NOTIFICATION_TEXT.ID];
    const notificationsTimeout = fields[DESKTOP_NOTIFICATION_FIELDS.NOTIFICATIONS_TIMEOUT.ID];
    const showNotificationsTimeout = fields[DESKTOP_NOTIFICATION_FIELDS.SHOW_NOTIFICATIONS_TIMEOUT.ID];

    const dispatchUpdate = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.UPDATE_DESKTOP_NOTIFICATION,
                payload: { fieldId, value }
            });
        },
        [dispatch]
    );

    const backToDefault = useCallback(
        (fieldId, value) => {
            dispatch({
                type: actions.BACK_TO_DEFAULT,
                payload: { tabId: DESKTOP_NOTIFICATION.ID, defaultData: defaultData }
            });
        },
        [dispatch, defaultData]
    );

    return (
        <>
            {notificationIcon && <ImageUpload field={notificationIcon} allowRemove changed={dispatchUpdate} />}
            {notificationBackground && (
                <ImageUpload field={notificationBackground} allowRemove changed={dispatchUpdate} />
            )}
            {displayIconEnabled && <SwitchField field={displayIconEnabled} changed={dispatchUpdate} />}
            {notificationHeight && <TextInput field={notificationHeight} changed={dispatchUpdate} />}
            {notificationWidth && <TextInput field={notificationWidth} changed={dispatchUpdate} />}
            {windowPosition && (
                <SelectField
                    field={windowPosition}
                    changed={dispatchUpdate}
                    options={[
                        { value: true, label: 'Center' },
                        { value: false, label: 'Next to tray icon' }
                    ]}
                />
            )}
            {notificationTitle && <TextInput field={notificationTitle} changed={dispatchUpdate} />}
            {mfaNotificationText && (
                <TextInput field={mfaNotificationText} type="textarea" rows="3" changed={dispatchUpdate} />
            )}
            {timeoutNotificationText && (
                <TextInput field={timeoutNotificationText} type="textarea" rows="3" changed={dispatchUpdate} />
            )}
            {notificationsTimeout && showNotificationsTimeout && (
                <TextInput
                    field={notificationsTimeout}
                    disabled={!showNotificationsTimeout.value}
                    changed={dispatchUpdate}>
                    <SwitchField field={showNotificationsTimeout} changed={dispatchUpdate} marginTop="none" />
                </TextInput>
            )}
            <Button onClick={backToDefault}>Reset defaults</Button>
        </>
    );
};

export default React.memo(DesktopNotification);
